import React from 'react';
import styled from 'styled-components';
import { cssSpacing, KeyboardDetectionProvider, screenMdMin, screenSmMax, } from '@spotify-internal/encore-web';
import { ContentfulImage, Grid, ImageAspectBox21x9, SectionHeader, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { ThreeUpSegment } from './ThreeUpSegment';
const Wrapper = styled(Grid) `
  padding-top: ${cssSpacing('looser')};
  padding-bottom: ${cssSpacing('looser')};
`;
const ThreeUp = styled.div `
  grid-column: 1 /-1;
  display: flex;
  flex-direction: column;
  padding-bottom: ${cssSpacing('looser')};

  & h1,
  h2 {
    padding-top: ${cssSpacing('base')};
    padding-bottom: ${cssSpacing('tighter-2')};
    z-index: 1;
  }

  @media (min-width: ${screenMdMin}) {
    & h1 {
      padding-bottom: ${cssSpacing('looser-4')};
    }
  }

  @media (max-width: ${screenSmMax}) {
    padding-bottom: ${cssSpacing('tighter-2')};

    [data-aspect-ratio='21x9'] {
      order: 1;
    }
  }
`;
const HeaderContent = styled.div `
  display: flex;
  flex-direction: column;
  padding-top: ${(props) => props.padding};

  @media (max-width: ${screenSmMax}) {
    padding-top: 0px;
    padding-bottom: ${cssSpacing('base')};
    flex-direction: column-reverse;
  }
`;
const SectionHeaderWrapper = styled.div `
  max-width: 815px;
  display: flex;
  flex-direction: column;
  padding-top: ${cssSpacing('looser')};
  padding-bottom: ${cssSpacing('looser-4')};
  z-index: 1;

  @media (max-width: ${screenSmMax}) {
    padding-top: ${cssSpacing('base')};
    padding-bottom: ${cssSpacing('base')};
    flex-direction: column-reverse;
  }
`;
const Bottom = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
    gap: ${cssSpacing('looser-4')};
  }
`;
const SegmentWrapper = styled.div `
  width: 25%;
  z-index: 1;

  @media (max-width: ${screenSmMax}) {
    width: 100%;
  }
`;
export const ThreeUpModule = React.forwardRef(({ headline = '', supertext = '', image, caption = '', segments = [], colors, transparent, }, ref) => {
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors, transparent: transparent, "data-testid": "color-set-wrapper" },
            React.createElement(Wrapper, null,
                React.createElement(ThreeUp, { ref: ref },
                    React.createElement(HeaderContent, { padding: image ? `${cssSpacing('looser')}` : '0px' },
                        image && (React.createElement(ImageAspectBox21x9, null,
                            React.createElement(ContentfulImage, { asset: image, caption: caption }))),
                        headline && (React.createElement(SectionHeaderWrapper, null,
                            React.createElement(SectionHeader, { heading: headline, eyebrow: supertext })))),
                    React.createElement(Bottom, null, segments.map(segment => (React.createElement(SegmentWrapper, { key: segment.headline },
                        React.createElement(ThreeUpSegment, { threeUpSegment: segment }))))))))));
});
